// @ts-nocheck
import { EllipsisV } from '@alefeducation/ui-elements-library-icons';
import React, { useEffect, useRef, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import RenderIf from '../Common/renderIf';

interface Actions {
  name?: string;
  callback: (row) => void;
  icon: React.ReactElement;
  shouldRender?: boolean;
  testId?: string;
  isDisabled?: boolean;
}
interface DataGridActionsPropsType {
  row: any;
  actions: Actions[];
}

const DataGridActions = (props: DataGridActionsPropsType) => {
  const { row, actions } = props;
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const actionHandler = (e, row, callback) => {
    e.stopPropagation();
    callback(row);
    ReactTooltip.hide();
  };

  const firstTwoActions = actions.slice(0, 2).filter((a) => a.shouldRender);
  const moreActions = actions.slice(2).filter((a) => a.shouldRender);
  return (
    <div className="flex items-center gap-4 data-grid-actions">
      {firstTwoActions.map((action, i) => (
        <button
          className="action-item"
          data-testid={action.testId || `action-${i}`}
          data-qa={action.testId || `action-${i}`}
          key={`first-action-item-${10 + i}`}
          onClick={(e) => actionHandler(e, row, action.callback)}
          data-tip={action.isDisabled ? '' : action?.name || ''}
          disabled={action.isDisabled}
        >
          {action.icon}
        </button>
      ))}
      <RenderIf condition={moreActions.length > 0}>
        <div className="action-item more-actions" ref={menuRef}>
          <EllipsisV
            data-testid="more-actions"
            onClick={(e) => actionHandler(e, !isOpen, setIsOpen)}
            data-tip={'More Actions'}
          />
          <RenderIf condition={isOpen}>
            <div className="multiple-action-menu">
              {moreActions.map((action, i) => (
                <button
                  className="multiple-action-menu-item"
                  data-testid={action.testId || `action-${i}`}
                  data-qa={action.testId || `action-${i}`}
                  key={action.name}
                  onClick={(e) => actionHandler(e, row, action.callback)}
                  disabled={action.isDisabled}
                >
                  {action.icon}
                  {action.name}
                </button>
              ))}
            </div>
          </RenderIf>
        </div>
      </RenderIf>
    </div>
  );
};

export default DataGridActions;
